import { useSelector } from '@betty/toolkit/state';
import { useMemo } from 'react';
import {
  selectPendingRewardsCount,
  selectStatus,
  selectStatusDataState,
} from '../state/status.slice';

const useStatus = () => {
  const status = useSelector(selectStatus);
  const statusDataState = useSelector(selectStatusDataState);
  const pendingRewardsCount = useSelector(selectPendingRewardsCount);
  const returnObj = useMemo(
    () => ({
      status,
      pendingRewardsCount,
      statusDataState,
    }),
    [status, statusDataState, pendingRewardsCount],
  );

  return returnObj;
};

export default useStatus;
